import { observable, runInAction } from 'mobx';
import { get } from '../utils';

class SearchList {
    private route: string;
    private params: any;
    @observable
    public searchListData: any;

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    async fetch(callback?, errs?) {
        var obj = Object.assign(this.params);
        get(this.route, obj).then((d) => {
            let data;
            if (d.data) {
                data = d.data;
                runInAction(() => {
                    this.searchListData = data;
                    callback && (this.searchListData = callback(data));
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }
}

export default SearchList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/SearchList.ts